<!-- HM footer default - standard HIPAAMATE footer -->
<template>
  <div :class="classList">
    &copy; 2018-2022 HIPAAMATE, LLC. All Rights Reserved.
  </div>
</template>

<script>
export default {
  name: "HMFooterDefault",
  data() {
    return {};
  },
  computed: {
    classList() {
      return ["text-center", "pt-5", "pb-2"];
    }
  }
};
</script>
